<template>
    <div v-if="loaded">
        <section class="h5maker-header">
            <div class="px-3">
                <button class="btn btn-sm fs-6 fw-bold" @click="$router.back()"> <i class="bi bi-chevron-left"></i> </button>
            </div>
            <div class="py-3 fw-bold">{{ info.title }}</div>
            <div class="flex-grow-1 text-end px-3">
                <div class="button-toolbar">
                    <button class="btn btn-sm btn-outline px-3 me-2" @click="save"> 预览 </button>
                    <button class="btn btn-sm btn-outline px-3 me-2" :disabled="saving || submitting" @click="save">
                        <i v-if="saving" class="el-icon-loading"></i>
                        <i v-else class="bi bi-cloud-arrow-up"></i>
                        保存 </button>
                    <button class="btn btn-sm rounded el-button--primary px-3 me-2" :disabled="saving || submitting"
                        @click="submit">
                        <i v-if="submitting" class="el-icon-loading"></i>
                        <i v-else class="el-icon-position me-1"></i>
                        发布更新 </button>
                </div>
            </div>
        </section>
        <page-editor :value="view" :last-save-time="lastSaveTime" @change="onViewChange"></page-editor>
    </div>
</template>
<script>
import api from './api'
import PageEditor from './PageEditor.vue'
import { imageUpload } from './api/imageUpload'

export default {
    components: { PageEditor },
    data() {
        return {
            loaded: true,
            saving: false,
            lastSaveTime: 0,
            submitting: false,
            auto_save_timer: null,
            view: [
                {
                    type: 'info',
                    title: '',
                    // title: `新页面-${new Date().toLocaleDateString()}`
                }
            ]
        }
    },
    computed: {
        info() {
            return this.view[0]
        }
    },
    mounted() {
        this.startKeydownHandler() // 开启键盘事件监控
        this.fetchOne()
    },
    methods: {
        async fetchOne() {
            const id = this.$route.params.id
            if (id) {
                const res = await api.fetchOne(id)
                this.$set(this, 'view', JSON.parse(res.data.json))
            }
        },
        onViewChange(e) {
            this.$set(this, 'view', e)
        },
        // 保存 { is_published: 0 }
        async save(config = {}) {
            if (this.saving) return // 防止不停提交
            this.saving = true // 保存中

            await this.uploadData(async (callback) => {
                const form = JSON.parse(JSON.stringify(this.view)) // JSON 转换会丢失 formData
                try {
                    const res = await api.addByForm(form)
                    const id = res.data ? res.data.id : null
                    if (id) {
                        this.$message.success('已保存')

                        this.$nextTick(() => {
                            this.$router.replace({ name: 'h5makerEdit', params: { id } })
                            this.saving = false
                        })
                    }
                } catch (e) {
                    this.$message('保存失败!' + e.toString())
                    this.saving = false // 延迟恢复按钮状态
                }
            })
        },
        // 发布
        async submit() {
            if (this.submitting) return // 防止不停提交

            this.submitting = true

            // JSON 转换会丢失 formData
            const form = JSON.parse(JSON.stringify(this.view))

            if (form.length == 1) {
                this.$message.error('请添加模块！')
                this.submitting = false
                return
            }
            // 检测内容是否完整
            for (let i of form) {
                if (i.data && i.data.length == 0 && !['divide'].includes(i.type)) {
                    this.$message.error(`请补充 ${this.typeList[i.type].name} 模块的完整信息!`)
                    this.submitting = false
                    return
                }
            }

            await this.uploadData(async (callback) => {
                const form = JSON.parse(JSON.stringify(this.view)) // JSON 转换会丢失 formData
                try {
                    const res = await api.addByForm(form, { is_published: 1 })
                    const id = res.data ? res.data.id : null
                    if (id) {
                        this.$message.success('发布成功')

                        this.$nextTick(() => {
                            this.$router.replace({ name: 'h5makerShare', params: { id } })
                            this.submitting = false
                        })
                    }
                } catch (e) {
                    this.$message('发布失败!' + e.toString())
                    this.submitting = false // 延迟恢复按钮状态
                }
            })
        },

        // 上传图片数据
        async uploadData(callback) {
            // JSON 转换会丢失 formData
            const form = JSON.parse(JSON.stringify(this.view))

            // 上传图片，修改数据字段
            const uploadPromise = {}
            for (let i = 0; i < this.view.length; i++) {
                if (['images', 'banner', 'navbar', 'article'].includes(this.view[i].type)) {
                    uploadPromise[i] = []
                    let list = this.view[i]['data']
                    list.forEach((item, index) => {
                        // 检测是否已经上传过
                        if (item.url.indexOf('https') < 0) {
                            uploadPromise[i].push(
                                new Promise((resolve, reject) => {
                                    const link = item.link
                                    const name = item.name
                                    imageUpload(item.form).then(res => {    // 上传图片接口
                                        form[i]['data'][index].url = res.data.url
                                        this.view[i]['data'][index].url = res.data.url
                                        resolve(res)
                                    }).catch(err => {
                                        reject(err)
                                    })
                                })
                            )
                        } else {
                            // do nothing
                        }
                    })
                } else {
                    // 没有需要上传的图片
                }
            }

            let [len, count] = [Object.keys(uploadPromise).length, 0]
            if (len) {
                for (let i in uploadPromise) {
                    Promise.all(uploadPromise[i]).then(res => {
                        count++
                        if (count === len) {
                            callback(true)
                            return Promise.resolve(true) // 已全部上传完成
                        }
                    }).catch(err => {
                        this.$message.error(err)
                    })
                }
            } else {
                callback(true)
                return Promise.resolve(true) // 没有需要上传的图片
            }
        },
        // 监听键盘事件
        startKeydownHandler() {
            document.onkeydown = (e) => {
                // 快捷键 ctrl + s 保存
                if ((e.ctrlKey || e.metaKey) && e.key === "s") {
                    // this.autoSave(0)
                    this.save()
                    e.preventDefault();
                }
            };
        },
    },
}
</script>